import React, { useState, useEffect, useCallback } from "react";
import styled from "styled-components";
import { FaUserClock, FaTimes } from "react-icons/fa";

const NotificationWrapper = styled.div`
  position: fixed;
  top: 80px; /* Positioned below the header */
  right: 20px;
  background-color: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border-radius: 10px;
  width: 320px;
  padding: 1rem;
  z-index: 1000;
  transform: translateX(${(props) => (props.show ? "0" : "120%")});
  transition: transform 0.3s ease-in-out;
`;

const NotificationHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.5rem;

  h4 {
    margin: 0;
    color: #f59e0b; /* Amber color for request notifications */
    display: flex;
    align-items: center;

    svg {
      margin-right: 0.5rem;
    }
  }

  button {
    background: none;
    border: none;
    cursor: pointer;
    color: #7f8c8d;

    &:hover {
      color: #2c3e50;
    }
  }
`;

const NotificationContent = styled.div`
  p {
    margin: 0.5rem 0;
    font-size: 0.875rem;
  }

  .highlight {
    font-weight: 500;
  }

  .request-details {
    background-color: #f5f7fa;
    padding: 0.75rem;
    border-radius: 5px;
    margin-top: 0.5rem;
    font-size: 0.8125rem;
  }

  .action-text {
    color: #2196f3;
    font-weight: 500;
    margin-top: 0.5rem;
  }
`;

const IncomingRequestNotification = ({ user, onClose, onViewRequest }) => {
  const [show, setShow] = useState(false);

  // Animate the notification in
  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(true);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  // Auto dismiss after a period
  const handleClose = useCallback(() => {
    setShow(false);

    // Give time for exit animation before removing from DOM
    setTimeout(() => {
      if (onClose) onClose();
    }, 300);
  }, [onClose]);
  
  useEffect(() => {
    if (show) {
      const timer = setTimeout(() => {
        handleClose();
      }, 6000); // Auto dismiss after 6 seconds

      return () => clearTimeout(timer);
    }
  }, [show, handleClose]);

  const handleViewRequest = () => {
    if (onViewRequest) onViewRequest();
    handleClose();
  };

  return (
    <NotificationWrapper show={show}>
      <NotificationHeader>
        <h4>
          <FaUserClock />
          Incoming Request
        </h4>
        <button onClick={handleClose}>
          <FaTimes />
        </button>
      </NotificationHeader>
      <NotificationContent>
        <p>
          You have a new appointment request from{" "}
          <span className="highlight">{user.name}</span>.
        </p>
        <div className="request-details">
          <p>Role: {user.role}</p>
          <p>Status: <span style={{ color: "#f59e0b" }}>Waiting for response</span></p>
          <p className="action-text" onClick={handleViewRequest} style={{ cursor: "pointer" }}>
            Click here to view and respond to the request
          </p>
        </div>
      </NotificationContent>
    </NotificationWrapper>
  );
};

export default IncomingRequestNotification;
